import React from "react";
import { Banner, Text } from "@shopify/polaris";
import { useSelector } from "react-redux";

/*
 * Red "setup broken" banner shown on the dashboard (below the promo banner) when
 * a merchant who already finished onboarding later turns OFF the app embed or
 * changes the currency formatting. It points them straight to the fix.
 * `status` = { currencyValid, appEmbedValid } from /validate-integration.
 */
function SetupIssueBanner({ status }) {
    const { shop_data } = useSelector((store) => store.commonData.store_data);
    const store = shop_data?.store_name;
    const appEmbedUrl = store
        ? `https://${store}/admin/themes/current/editor?context=apps&appEmbed=${process.env.EXTENSION_UUID}/${process.env.EXTENSION_BLOCK_NAME}`
        : "";
    const currencyUrl = store ? `https://${store}/admin/settings/general` : "";

    const embedOff = !status?.appEmbedValid;
    const formattingOff = !status?.currencyValid;
    if (!embedOff && !formattingOff) return null;

    // The app embed being off is the priority - the converter is fully invisible.
    let title, message, action, secondaryAction;
    if (embedOff) {
        title = "Currency converter is turned off";
        message = "Your app embed is disabled, so prices aren't converting on your storefront. Re-enable it to turn the converter back on.";
        action = { content: "Enable app embed", url: appEmbedUrl, external: true };
        if (formattingOff) {
            secondaryAction = { content: "Fix currency formatting", url: currencyUrl, external: true };
        }
    } else {
        title = "Currency formatting needs attention";
        message = "Your store's currency formatting was changed, so prices may not convert correctly. Update it to fix conversions.";
        action = { content: "Open currency settings", url: currencyUrl, external: true };
    }

    return (
        <div style={{ marginBottom: 16 }}>
            <Banner tone="critical" title={title} action={action} secondaryAction={secondaryAction}>
                <Text as="p" variant="bodyMd">{message}</Text>
            </Banner>
        </div>
    );
}

export default SetupIssueBanner;
